import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        {/* <path
          d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
          fill="currentColor"
        /> */}

        <path
          d="M 10.437 19.292 L 5.251 19.292 L 5.251 32.124 L 0 32.124 L 0 0 L 9.075 0 A 26.561 26.561 0 0 1 12.317 0.184 Q 15.912 0.628 18.027 2.139 A 7.655 7.655 0 0 1 18.281 2.329 A 7.467 7.467 0 0 1 20.978 6.654 A 11.792 11.792 0 0 1 21.27 9.361 Q 21.27 15.359 15.029 17.908 L 24.104 32.124 L 18.127 32.124 L 10.437 19.292 Z M 5.251 4.439 L 5.251 14.942 L 8.899 14.942 A 15.689 15.689 0 0 0 10.755 14.84 Q 13.019 14.569 14.216 13.579 A 4.371 4.371 0 0 0 15.683 11.171 Q 15.861 10.438 15.864 9.564 A 8.679 8.679 0 0 0 15.864 9.536 A 6.535 6.535 0 0 0 15.707 8.054 Q 15.477 7.064 14.906 6.367 A 3.718 3.718 0 0 0 14.084 5.625 A 5.879 5.879 0 0 0 12.573 4.926 Q 11.118 4.47 9.016 4.441 A 20.957 20.957 0 0 0 8.723 4.439 L 5.251 4.439 Z"
          transform="translate(28, 28)"
          fill="currentColor"
        />

        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
